import styled from 'styled-components/macro';
import { FocusableParent } from 'components/navigation';
import scaleSize from 'utils/scale-size';
import PageTitle from 'components/PageTitle';

export const StyledProfileButtonsWrapper = styled(FocusableParent)`
  margin-top: ${scaleSize(340)}px;
  margin-left: ${scaleSize(220)}px;
  white-space: nowrap;
  transform: ${({ offset = 0 }) => `translate3d(-${offset}px, 0, 0)`};
`;

export const StyledProfileTitle = styled(PageTitle)`
  top: ${scaleSize(60)}px;
  left: ${scaleSize(220)}px;
  font-family: 'RobotoMedium', sans-serif;
`;

export const StyledSettingsPage = styled.div`
  width: ${scaleSize(1920)}px;
  height: ${scaleSize(1080)}px;
`;

export const StyledSettingsPageTitle = styled(StyledProfileTitle)`
  font-size: ${scaleSize(48)}px;
  line-height: 1.5;
  letter-spacing: -0.33px;
`;
